module.exports = __webpack_public_path__ + "img/logo.ad57cbe5.png";